import { memo, useEffect, useLayoutEffect } from 'react'
import { loadSmplrJs } from '@smplrspace/smplr-loader';
import { Space } from '@smplrspace/smplr-loader/dist/generated/smplr';
import { useAppDispatch } from '../../../store/store';
import { notificationFail } from '../../../store/slices/notificationSlice';


const Viewer = memo(({ onReady, onError, spaceId, mode, space, containerStyle }: { containerStyle?: React.CSSProperties, space: Space | undefined, mode?: string, spaceId: string; onReady: (space: Space | undefined) => void, onError: (error: any) => void }) => {

    // function onLoad() {
    //     loadSmplrJs('umd').then((smplr) => {
    //         const space = new smplr.Space({
    //             spaceId: 'edb2ebaa-47ea-4e54-af0d-cf543328bdb0',
    //             clientToken: process?.env?.REACT_APP_SMPLR_CLIENT_ID || '',
    //             containerId: 'smplr-container'
    //         })
    //         space.startViewer({
    //             preview: true,
    //             mode,
    //             allowModeChange: true,
    //             onReady: () => onReady(space),
    //             onError: error => console.error('Could not start viewer', error)
    //         })
    //     })
    // }
    // console.log(space ? space?.getCameraPlacement() : '0', 'hello world');

    const dispatch = useAppDispatch()
    useEffect(() => {
        if (!spaceId) {
            space?.remove();
            onReady(undefined);
            return
        };
        const clientToken = process.env.REACT_APP_SMPLR_CLIENT_ID || '';
        let spaceTmp: any = null;
        loadSmplrJs('umd').then((smplr) => {
            spaceTmp = new smplr.Space({
                spaceId: spaceId,
                clientToken,
                containerId: 'view-data-container',
            })
            spaceTmp.startViewer({
                // preview: true,
                // includeLevels: [1],
                // experimentalFacadeBasedPerformance: true,
                // autoRotate: true,
                // compass: true,
                // annotations: true,
                // topShownLevel: 1,
                // cameraPlacement: {
                //     alpha: -0.6606080215248583,
                //     beta: 1.0203878243399123,
                //     radius: 4.813626051700399,
                //     target: {
                //         x: 4.977461230115259,
                //         y: 2.3058007500772018,
                //         z: -2.885045351615471
                //     },
                //     animate: true,
                //     animationDuration: 1
                // },
                mode: mode || '3d',
                allowModeChange: true,
                onReady: () => onReady(spaceTmp),
                onError: (error: any) => {
                    onError(error)
                    console.error('Could not start viewer', error);
                }
            })
        }).catch((error: any) => {
            console.log(error);
            dispatch(notificationFail(error?.message?.replace("[smplr.js] Space error:", '')));
        })
        // import("https://app.smplrspace.com/lib/smplr.mjs").then((smplr) => {
        //     const space = new smplr.Space({
        //         spaceId: 'a47e1326-0764-4d27-8fc8-2506867978a8',
        //         clientToken,
        //         containerId: 'view-data-container',
        //     });
        //     space.startViewer({
        //         preview: true,
        //         onReady: () => console.log("Viewer is ready"),
        //         onError: (error: any) => console.error("Could not start viewer", error),
        //     });
        // });
    }, [spaceId, mode])

    return (
        <div className="smplr-wrapper" style={{ position: 'relative', ...(containerStyle || {}), height: (window?.innerWidth < 500 ? "25em" : "auto") }}>
            <div id='view-data-container' className="smplr-embed" style={{ position: 'absolute', width: '100%', height: '100%', backgroundColor: 'whitesmoke' }} />
        </div>
    )
});
export default Viewer;